import TopicTwo from "../../resource-contents/the-pips-insights-contents/TopicTwo";

const ThePipsInsightsContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Your Strategic Advantage</h1>
            <p>Actionable intelligence that guides your every trade.</p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Macro & Micro Analysi</h4>
                </div>
                <p>
                  Insights that connect the dots between big-picture economics
                  and individual market behavior.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Technical + Fundamental Blend</h4>
                </div>
                <p>
                  A hybrid approach to market interpretation, giving you both
                  chart-driven and data-backed perspectives.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Trader-Centric Focus</h4>
                </div>
                <p>
                  Every article is written to help traders turn insights into
                  practical, results-oriented actions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThePipsInsightsContentFive;
